import React, { PureComponent } from 'react';
import { bool, any, string } from 'prop-types';
import { Route } from 'react-router-dom';

class AuthorizedRoute extends PureComponent {
  static propTypes = {
    signedIn: bool.isRequired,
    component: any.isRequired,
    path: string.isRequired,
    exact: bool,
  };

  render() {
    const { signedIn, component, path, exact } = this.props;

    return signedIn ? <Route path={path} component={component} exact={exact} /> : null;
  }
}

export default AuthorizedRoute;
